import CNPJValidator from './CNPJValidator'
import CPFValidator from './CPFValidator'
import moment from 'moment'
import tableIcons from './TableUtil'

import 'moment/locale/pt-br'
moment.locale('pt-br')

const titleCase = (str) => {
  return str.replace(
    /\w\S*/g,
    function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  )
}

function dateOnlyString(dateObj) {
  if (dateObj instanceof Date)
    return dateObj.toJSON().slice(0, 10)
  return null
}

const rUUID = /(?:^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}$)|(?:^0{8}-0{4}-0{4}-0{4}-0{12}$)/u
const rEMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const rCNPJ = /^\d{14}$/

const isUuid = str => rUUID.test(str)
const isNullish = x => x === undefined || x === null

const today = () => moment()
const yesterday = () => moment().subtract(1, 'days')

const dateFormat = (date, onlyDate = false) => (onlyDate ? moment(date).format('DD/MM/YYYY') : moment(date).format('DD/MM/YYYY - HH:mm:ss'))
const dateFormatToPicker = (date, onlyDate = false) => (onlyDate ? moment(date).format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD HH:mm:ss'))

const startOfDay = (date) => moment(date).startOf('day')
const endOfDay = (date) => moment(date).endOf('day')
const endOfYesterdayDay = (date) => moment(date).subtract(1, 'days').endOf('day')

const humanizeDate = (date) => (moment(date).fromNow())

const getOnlyDay = (date) => (moment(date).format('DD'))
const getMonthAndYear = (date) => (moment(date).format('MMMM/YYYY'))
const getMonthAndYearToPicker = (date) => (moment(date).format('YYYY-MM'))

const copyToClipboard = (text, okStr = 'Content copied to Clipboard!', failStr = 'Unable to Copy to Clip Board!') => {
  try {
    if (window && window.getSelection) { window.getSelection().removeAllRanges(); }
    else if (document.selection) { document.selection.empty(); }

    var dummy = document.createElement("textarea");

    dummy.value = text

    document.body.appendChild(dummy);
    dummy.select()

    let success = document.execCommand("copy");
    document.body.removeChild(dummy);

    let msg = success ? okStr : failStr
    alert(msg)
  } catch (err) {
    alert(failStr)
  }
}

const downloadText = (data, fileName) => {
  var url = window.URL.createObjectURL(
    new Blob([data], { type: 'text/plain' })
  )

  var anchor = document.createElement("a");
  anchor.href = url
  anchor.id = 'downalod'
  anchor.setAttribute('download', `${fileName}.csv`)

  document.body.appendChild(anchor);
  anchor.click()

  window.URL.revokeObjectURL(url);
}

const downloadPdf = (base64Data, fileName) => {
  var anchor = document.createElement("a");
  anchor.href = 'data:application/octet-stream;base64,' + base64Data;
  anchor.id = 'download-pdf'
  anchor.setAttribute('download', `${fileName}.pdf`)

  document.body.appendChild(anchor);
  anchor.click()

  window.URL.revokeObjectURL(base64Data);
}

const getByString = (obj, s) => {
  let v = obj

  s.split('.').forEach(k => {
    if (v[k] !== undefined)
      v = v[k]
  })

  return v
}

function maskCpf(cpf) {
  if (typeof cpf !== 'string')
    return cpf

  return cpf.replace(/^(.{3})(.{3})(.{3})(.{2}).*/, "$1.$2.$3-$4");
}

function maskCnpj(cnpj) {
  if (typeof cnpj !== 'string')
    return cnpj

  return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, "$1.$2.$3/$4-$5");
}

function maskCurrency(v) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
    .format(Number(v) || 0); // Prevents NaN
}

export {
  getByString,
  dateOnlyString,
  maskCpf,
  maskCnpj,
  isUuid,
  isNullish,
  copyToClipboard,
  downloadText,
  CNPJValidator,
  CPFValidator,
  tableIcons,
  maskCurrency,
  today,
  yesterday,
  dateFormat,
  dateFormatToPicker,
  startOfDay,
  endOfDay,
  endOfYesterdayDay,
  humanizeDate,
  getOnlyDay,
  getMonthAndYear,
  getMonthAndYearToPicker,
  downloadPdf,
  titleCase,
  rEMAIL,
  rCNPJ
}